import React, { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import type { timeline_nativeIssueTable_TimelineCellRenderer$key } from '@atlassian/jira-relay/src/__generated__/timeline_nativeIssueTable_TimelineCellRenderer.graphql';
import { useCustomComponents } from '../../../../controllers/custom-components/index.tsx';
import type { CustomComponents } from '../../../types.tsx';

export type TimelineCellProps = {
	depth: number;
	groupId?: string;
	issueEdge: timeline_nativeIssueTable_TimelineCellRenderer$key;
};

export const TimelineCellRenderer: FC<TimelineCellProps> = ({ depth, groupId, issueEdge }) => {
	let customComponents: CustomComponents | null = null;

	if (fg('jira_native_issue_table_extra_custom_components')) {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		customComponents = useCustomComponents();
	}

	const issueEdgeData = useFragment(
		graphql`
			fragment timeline_nativeIssueTable_TimelineCellRenderer on JiraIssueEdge
			@argumentDefinitions(isTimelineEnabled: { type: "Boolean!" }) {
				# eslint-disable-next-line @atlassian/relay/must-colocate-fragment-spreads
				...timelineCell_issueTableTimeline @include(if: $isTimelineEnabled)
			}
		`,
		issueEdge,
	);

	return (
		customComponents?.timeline?.Cell && (
			<customComponents.timeline.Cell depth={depth} groupId={groupId} issueEdge={issueEdgeData} />
		)
	);
};
